<template>
  <div class="vz-individual-order-directions pdf-order-section">
    <div class="vz-individual-order-directions-title text-h1 mb-20">
      {{ title }}
    </div>
    <vz-loader :status-loader="pageLoader" />
    <vz-dispatch-direction
      :hide-waiting="hideWaiting"
      :disabled="isDisabled(false)"
    />
    <template v-if="isIndividual">
      <img
        src="/svg/vz-swap-arrow-red.svg"
        class="vz-individual-order-directions-swap-btn"
        @click="onSwapDirections"
      >
      <div class="vz-direction-card">
        <vz-destination-direction
          :hide-waiting="hideWaiting"
          :disabled="isDisabled(true)"
        />
      </div>
    </template>
    <vz-network-direction
      v-else
      class="vz-direction-card"
      :disabled="isDisabled(true)"
    />
  </div>
</template>

<script setup lang="ts">
import {useLayoutStore} from '~/stores/personal/layout';
import {useOrderStore} from '~/stores/order';
import {storeToRefs} from 'pinia';
import VzDispatchDirection from '~/components/personal/order/direction/vz-dispatch-direction.vue';
import VzDestinationDirection from '~/components/personal/order/direction/vz-destination-direction.vue';
import VzNetworkDirection from '~/components/personal/order/direction/vz-network-direction.vue';

const props = defineProps({
  title: {
    type: String,
    default: 'Направление'
  },
  hideWaiting: {
    type: Boolean,
    default: false
  }
})

const { pageLoader } = storeToRefs(useLayoutStore())
const orderStore = useOrderStore()

const isCloned = computed(() => {
  return !!useRoute().query.clone || false
})

const isIndividual = computed(() => {
  return orderStore.orderType === 'individual'
})

const isDispatchAddressPoint = computed(() => {
  return orderStore.orderForm.directions.dispatch.direction === 'address'
})

function isDisabled(directionTo = false) {
  if (orderStore.orderForm?.meta?.lockState) {
    const { dispatch, destination } = orderStore.orderForm?.meta?.lockState
    return (directionTo ? destination : dispatch) && !isCloned.value
  }
  return false
}

async function onSwapDirections() {
  if (!isDisabled(false) && !isDisabled(true)) {
    if (orderStore.orderForm.directions.destination.direction === 'pickupPoint') {
      orderStore.orderForm.directions.destination.direction = 'address'
    }

    const keys = ['locationGuid', 'direction', 'address', 'terminalGuid', 'fake', 'country']
    keys.forEach(key => {
      const directions = orderStore.orderForm.directions as any
      const tmp = directions.dispatch[key]
      directions.dispatch[key] = directions.destination[key]
      directions.destination[key] = tmp
    })

    const tmpRoadmapActive = orderStore.orderForm.specialRequirements.dispatch.roadmap.active
    const tmpRoadmapOldActive = orderStore.orderForm.specialRequirements.dispatch.roadmap.oldActive
    const tmpRoadmapValue = orderStore.orderForm.specialRequirements.dispatch.roadmap.value
    orderStore.orderForm.specialRequirements.dispatch.roadmap.active = orderStore.orderForm.specialRequirements.destination.roadmap.active
    orderStore.orderForm.specialRequirements.destination.roadmap.active = tmpRoadmapActive
    orderStore.orderForm.specialRequirements.dispatch.roadmap.oldActive = orderStore.orderForm.specialRequirements.destination.roadmap.oldActive
    orderStore.orderForm.specialRequirements.destination.roadmap.oldActive = tmpRoadmapOldActive
    orderStore.orderForm.specialRequirements.dispatch.roadmap.value = orderStore.orderForm.specialRequirements.destination.roadmap.value
    orderStore.orderForm.specialRequirements.destination.roadmap.value = tmpRoadmapValue


    const tmpCustomerCountry = orderStore.orderForm.customer.dispatch.country
    orderStore.orderForm.customer.dispatch.country = orderStore.orderForm.customer.destination.country
    orderStore.orderForm.customer.destination.country = tmpCustomerCountry
  }
}
</script>

<style lang="scss">

</style>
